import { z } from 'zod'
import { USER_ROLES } from '../enums'
import { optionalText, requiredText } from './common'

export const userInputSchema = z.object({
  email: z.string().trim().toLowerCase().email('כתובת דואר אלקטרוני לא תקינה').max(255),
  name: requiredText(200, 'שם הוא שדה חובה'),
  role: z.enum(USER_ROLES),
  isActive: z.boolean().default(true),
})

export type UserInput = z.infer<typeof userInputSchema>

export const userQuerySchema = z.object({
  search: optionalText(200),
  includeInactive: z
    .preprocess((v) => (v === 'true' || v === true ? true : v === 'false' || v === false ? false : v), z.boolean().default(false)),
})

export type UserQuery = z.infer<typeof userQuerySchema>

export type UserDto = {
  id: string
  email: string
  name: string
  role: (typeof USER_ROLES)[number]
  isActive: boolean
  createdAt: string
  updatedAt: string
}
